import { Component, Input } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "./table.utils";
import * as i3 from "@angular/common";
import * as i4 from "./child.component";
import * as i5 from "./table.cell.component";
import * as i6 from "./localfilter.pipe";
const _c0 = ["DataTable-table-body", ""];
const _c1 = function (a0, a1, a2, a3) { return { open: a0, closed: a1, "fa-caret-down": a2, "fa-caret-right": a3 }; };
function DataTableBodyComponent_ng_container_0_ng_container_1_td_2_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "td", 5)(1, "button", 6);
    i0.ɵɵlistener("click", function DataTableBodyComponent_ng_container_0_ng_container_1_td_2_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r13); const i_r7 = i0.ɵɵnextContext().index; const ctx_r11 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r11.toggleChild(i_r7)); });
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const i_r7 = i0.ɵɵnextContext().index;
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(2, _c1, ctx_r8.childOpen(i_r7), !ctx_r8.childOpen(i_r7), ctx_r8.childOpen(i_r7), !ctx_r8.childOpen(i_r7)));
    i0.ɵɵattribute("aria-expanded", ctx_r8.childOpen(i_r7));
} }
function DataTableBodyComponent_ng_container_0_ng_container_1_ng_container_3_td_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c2 = function (a0, a1) { return { right: a0, "button-column": a1 }; };
function DataTableBodyComponent_ng_container_0_ng_container_1_ng_container_3_td_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "td", 10);
    i0.ɵɵtemplate(1, DataTableBodyComponent_ng_container_0_ng_container_1_ng_container_3_td_1_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r15 = i0.ɵɵnextContext().$implicit;
    const _r18 = i0.ɵɵreference(4);
    const row_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r16 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c2, column_r15.alignRight, ctx_r16.sortable && !column_r15.unsortable))("ngStyle", ctx_r16.addStyleToCell(row_r4, column_r15));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r18);
} }
function DataTableBodyComponent_ng_container_0_ng_container_1_ng_container_3_th_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainer(0);
} }
const _c3 = function (a0, a1) { return { right: a0, "button-column": a1, "row-header": true }; };
function DataTableBodyComponent_ng_container_0_ng_container_1_ng_container_3_th_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "th", 12);
    i0.ɵɵtemplate(1, DataTableBodyComponent_ng_container_0_ng_container_1_ng_container_3_th_2_ng_container_1_Template, 1, 0, "ng-container", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const column_r15 = i0.ɵɵnextContext().$implicit;
    const _r18 = i0.ɵɵreference(4);
    const row_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r17 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(3, _c3, column_r15.alignRight, ctx_r17.sortable && !column_r15.unsortable))("ngStyle", ctx_r17.addStyleToCell(row_r4, column_r15));
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", _r18);
} }
function DataTableBodyComponent_ng_container_0_ng_container_1_ng_container_3_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "DataTable-cell", 13);
} if (rf & 2) {
    const column_r15 = i0.ɵɵnextContext().$implicit;
    const row_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("column", column_r15)("row", row_r4);
} }
function DataTableBodyComponent_ng_container_0_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableBodyComponent_ng_container_0_ng_container_1_ng_container_3_td_1_Template, 2, 6, "td", 7);
    i0.ɵɵtemplate(2, DataTableBodyComponent_ng_container_0_ng_container_1_ng_container_3_th_2_Template, 2, 6, "th", 8);
    i0.ɵɵtemplate(3, DataTableBodyComponent_ng_container_0_ng_container_1_ng_container_3_ng_template_3_Template, 1, 2, "ng-template", null, 9, i0.ɵɵtemplateRefExtractor);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const column_r15 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", !column_r15.rowHeader);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", column_r15.rowHeader);
} }
function DataTableBodyComponent_ng_container_0_ng_container_1_tr_4_DataTable_child_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "DataTable-child", 16);
} if (rf & 2) {
    const ctx_r29 = i0.ɵɵnextContext(2);
    const row_r4 = ctx_r29.$implicit;
    const i_r7 = ctx_r29.index;
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("component", ctx_r28.childComponent)("row", row_r4)("rowIndex", i_r7)("openChildren", ctx_r28.openChildren);
} }
const _c4 = function (a0, a1, a2) { return { odd: a0, even: a1, rowOpen: a2 }; };
function DataTableBodyComponent_ng_container_0_ng_container_1_tr_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 14);
    i0.ɵɵelement(1, "td");
    i0.ɵɵelementStart(2, "td");
    i0.ɵɵtemplate(3, DataTableBodyComponent_ng_container_0_ng_container_1_tr_4_DataTable_child_3_Template, 1, 4, "DataTable-child", 15);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext();
    const o_r6 = ctx_r30.odd;
    const e_r5 = ctx_r30.even;
    const i_r7 = ctx_r30.index;
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(4, _c4, o_r6, e_r5, ctx_r10.childOpen(i_r7)))("hidden", !ctx_r10.childOpen(i_r7));
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("colspan", ctx_r10.currentColumns == null ? null : ctx_r10.currentColumns.length);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r10.childComponent);
} }
const _c5 = function (a0, a1, a2, a3) { return { odd: a0, even: a1, rowLink: a2, rowOpen: a3 }; };
function DataTableBodyComponent_ng_container_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tr", 2);
    i0.ɵɵlistener("click", function DataTableBodyComponent_ng_container_0_ng_container_1_Template_tr_click_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r32); const row_r4 = restoredCtx.$implicit; const ctx_r31 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r31.rowClick(row_r4)); })("keyup.enter", function DataTableBodyComponent_ng_container_0_ng_container_1_Template_tr_keyup_enter_1_listener() { const restoredCtx = i0.ɵɵrestoreView(_r32); const row_r4 = restoredCtx.$implicit; const ctx_r33 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r33.rowClick(row_r4)); });
    i0.ɵɵtemplate(2, DataTableBodyComponent_ng_container_0_ng_container_1_td_2_Template, 2, 7, "td", 3);
    i0.ɵɵtemplate(3, DataTableBodyComponent_ng_container_0_ng_container_1_ng_container_3_Template, 5, 2, "ng-container", 1);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, DataTableBodyComponent_ng_container_0_ng_container_1_tr_4_Template, 4, 8, "tr", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r4 = ctx.$implicit;
    const e_r5 = ctx.even;
    const o_r6 = ctx.odd;
    const i_r7 = ctx.index;
    const ctx_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction4(6, _c5, o_r6, e_r5, ctx_r3.linkTarget, ctx_r3.childOpen(i_r7)))("ngStyle", ctx_r3.rowStylingFunction(row_r4));
    i0.ɵɵattribute("tabindex", ctx_r3.linkTarget ? 0 : null);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.childRows);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r3.currentColumns);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.childRows);
} }
const _c6 = function (a0, a1, a2, a3, a4, a5) { return [a0, a1, a2, a3, a4, a5]; };
function DataTableBodyComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, DataTableBodyComponent_ng_container_0_ng_container_1_Template, 5, 11, "ng-container", 1);
    i0.ɵɵpipe(2, "localfilter");
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBindV(2, 1, i0.ɵɵpureFunction6(8, _c6, ctx_r0.page.content, ctx_r0.currentColumns, ctx_r0.localFilter, ctx_r0.localPaging, ctx_r0.columnFiltering, ctx_r0.filter)));
} }
function DataTableBodyComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tr")(2, "td");
    i0.ɵɵtext(3, " There are no columns selected ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("colspan", ctx_r1.childRows ? ctx_r1.columns.length + 1 : ctx_r1.columns == null ? null : ctx_r1.columns.length);
} }
function DataTableBodyComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "tr")(2, "td");
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵattribute("colspan", ctx_r2.childRows ? ctx_r2.currentColumns.length + 1 : ctx_r2.currentColumns == null ? null : ctx_r2.currentColumns.length);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r2.tableEmptyMessage, " ");
} }
/**
 * This component controls each row in the table.
 */
export class DataTableBodyComponent {
    constructor(router, tableUtils) {
        this.router = router;
        this.tableUtils = tableUtils;
        this.currentColumns = [];
        this.columns = [];
        this.openChildren = [];
    }
    ngOnChanges(changes) {
        if (changes.hasOwnProperty('page') && !changes.page.isFirstChange()) {
            this.openChildren = [];
        }
    }
    addStyleToCell(row, column) {
        if (this.cellStylingFunction) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            const cellData = this.tableUtils.retrieveCell(row, column);
            return this.cellStylingFunction(row, column, cellData);
        }
        return null;
    }
    childOpen(index) {
        return this.openChildren.indexOf(index) > -1;
    }
    /**
     * Toggle the show/hide status of the child row
     */
    toggleChild(index) {
        if (this.openChildren.indexOf(index) > -1) {
            this.openChildren.splice(this.openChildren.indexOf(index), 1);
        }
        else {
            this.openChildren.push(index);
        }
        this.openChildren = this.openChildren.slice(0);
    }
    /**
     * If provided, navigate to link for this row using the router.
     */
    // eslint-disable-next-line @typescript-eslint/ban-types
    rowClick(row) {
        if (this.linkTarget && this.linkKey) {
            void this.router.navigate([this.linkTarget, this.tableUtils.findValue(row, this.linkKey)]);
        }
    }
}
DataTableBodyComponent.ɵfac = function DataTableBodyComponent_Factory(t) { return new (t || DataTableBodyComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2.DataTableUtils)); };
DataTableBodyComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: DataTableBodyComponent, selectors: [["", "DataTable-table-body", ""]], inputs: { currentColumns: "currentColumns", columns: "columns", localFilter: "localFilter", localPaging: "localPaging", columnFiltering: "columnFiltering", filter: "filter", rowStylingFunction: "rowStylingFunction", cellStylingFunction: "cellStylingFunction", childRows: "childRows", childComponent: "childComponent", linkTarget: "linkTarget", linkKey: "linkKey", tableEmptyMessage: "tableEmptyMessage", page: "page", sortable: "sortable" }, features: [i0.ɵɵNgOnChangesFeature], attrs: _c0, decls: 3, vars: 3, consts: [[4, "ngIf"], [4, "ngFor", "ngForOf"], [1, "data-row", 3, "ngClass", "ngStyle", "click", "keyup.enter"], ["class", "header-buttons", 4, "ngIf"], ["class", "data-row child-row", 3, "ngClass", "hidden", 4, "ngIf"], [1, "header-buttons"], ["type", "button", "aria-label", "Details Row", 1, "black-arrow", "fa", "fa-fw", 3, "ngClass", "click"], [3, "ngClass", "ngStyle", 4, "ngIf"], ["scope", "row", 3, "ngClass", "ngStyle", 4, "ngIf"], ["cellContents", ""], [3, "ngClass", "ngStyle"], [4, "ngTemplateOutlet"], ["scope", "row", 3, "ngClass", "ngStyle"], [3, "column", "row"], [1, "data-row", "child-row", 3, "ngClass", "hidden"], [3, "component", "row", "rowIndex", "openChildren", 4, "ngIf"], [3, "component", "row", "rowIndex", "openChildren"]], template: function DataTableBodyComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, DataTableBodyComponent_ng_container_0_Template, 3, 15, "ng-container", 0);
        i0.ɵɵtemplate(1, DataTableBodyComponent_ng_container_1_Template, 4, 1, "ng-container", 0);
        i0.ɵɵtemplate(2, DataTableBodyComponent_ng_container_2_Template, 4, 2, "ng-container", 0);
    } if (rf & 2) {
        i0.ɵɵproperty("ngIf", (ctx.page == null ? null : ctx.page.content) && ctx.currentColumns.length > 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (ctx.currentColumns == null ? null : ctx.currentColumns.length) === 0);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", (!(ctx.page == null ? null : ctx.page.content) || (ctx.page == null ? null : ctx.page.content == null ? null : ctx.page.content.length) === 0) && ctx.currentColumns.length > 0);
    } }, dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i3.NgTemplateOutlet, i3.NgStyle, i4.DataTableChildComponent, i5.DataTableCellComponent, i6.LocalFilterPipe], styles: ["\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(DataTableBodyComponent, [{
        type: Component,
        args: [{ selector: '[DataTable-table-body]', template: `
    <ng-container *ngIf="page?.content && currentColumns.length > 0">
      <ng-container
        *ngFor="
          let row of page.content
            | localfilter : currentColumns : localFilter : localPaging : columnFiltering : filter;
          let e = even;
          let o = odd;
          let i = index
        "
      >
        <tr
          class="data-row"
          [ngClass]="{ odd: o, even: e, rowLink: linkTarget, rowOpen: childOpen(i) }"
          [ngStyle]="rowStylingFunction(row)"
          (click)="rowClick(row)"
          (keyup.enter)="rowClick(row)"
          [attr.tabindex]="linkTarget ? 0 : null"
        >
          <td class="header-buttons" *ngIf="childRows">
            <button
              class="black-arrow fa fa-fw"
              [attr.aria-expanded]="childOpen(i)"
              [ngClass]="{
                open: childOpen(i),
                closed: !childOpen(i),
                'fa-caret-down': childOpen(i),
                'fa-caret-right': !childOpen(i)
              }"
              (click)="toggleChild(i)"
              type="button"
              aria-label="Details Row"
            ></button>
          </td>
          <ng-container *ngFor="let column of currentColumns">
            <td
              *ngIf="!column.rowHeader"
              [ngClass]="{
                right: column.alignRight,
                'button-column': sortable && !column.unsortable
              }"
              [ngStyle]="addStyleToCell(row, column)"
            >
              <ng-container *ngTemplateOutlet="cellContents"></ng-container>
            </td>
            <th
              *ngIf="column.rowHeader"
              [ngClass]="{
                right: column.alignRight,
                'button-column': sortable && !column.unsortable,
                'row-header': true
              }"
              [ngStyle]="addStyleToCell(row, column)"
              scope="row"
            >
              <ng-container *ngTemplateOutlet="cellContents"></ng-container>
            </th>
            <ng-template #cellContents>
              <DataTable-cell [column]="column" [row]="row"></DataTable-cell>
            </ng-template>
          </ng-container>
        </tr>
        <tr
          *ngIf="childRows"
          class="data-row child-row"
          [ngClass]="{ odd: o, even: e, rowOpen: childOpen(i) }"
          [hidden]="!childOpen(i)"
        >
          <td></td>
          <td [attr.colspan]="currentColumns?.length">
            <DataTable-child
              *ngIf="childComponent"
              [component]="childComponent"
              [row]="row"
              [rowIndex]="i"
              [openChildren]="openChildren"
            ></DataTable-child>
          </td>
        </tr>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="currentColumns?.length === 0">
      <tr>
        <td [attr.colspan]="childRows ? columns.length + 1 : columns?.length">
          There are no columns selected
        </td>
      </tr>
    </ng-container>
    <ng-container *ngIf="(!page?.content || page?.content?.length === 0) && currentColumns.length > 0">
      <tr>
        <td [attr.colspan]="childRows ? currentColumns.length + 1 : currentColumns?.length">
          {{ tableEmptyMessage }}
        </td>
      </tr>
    </ng-container>
  `, styles: ["/*# sourceMappingURL=table.component.css.map */\n"] }]
    }], function () { return [{ type: i1.Router }, { type: i2.DataTableUtils }]; }, { currentColumns: [{
            type: Input
        }], columns: [{
            type: Input
        }], localFilter: [{
            type: Input
        }], localPaging: [{
            type: Input
        }], columnFiltering: [{
            type: Input
        }], filter: [{
            type: Input
        }], rowStylingFunction: [{
            type: Input
        }], cellStylingFunction: [{
            type: Input
        }], childRows: [{
            type: Input
        }], childComponent: [{
            type: Input
        }], linkTarget: [{
            type: Input
        }], linkKey: [{
            type: Input
        }], tableEmptyMessage: [{
            type: Input
        }], page: [{
            type: Input
        }], sortable: [{
            type: Input
        }] }); })();
